export default __webpack_public_path__ + "static/media/myMemiii-Schrift.2527149a.png";